const AUTH_URL = process.env.REACT_APP_BASE_URL; // get from env-create an env file find url in spinup docs

export const ApiPath = {
  auth: `${AUTH_URL}`,
};
